import { render, staticRenderFns } from "./technical-error.vue?vue&type=template&id=124ce580&scoped=true&lang=pug"
import script from "./technical-error.vue?vue&type=script&lang=js"
export * from "./technical-error.vue?vue&type=script&lang=js"
import style0 from "./technical-error.vue?vue&type=style&index=0&id=124ce580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ce580",
  null
  
)

export default component.exports